<div class="row align-items-center">
    <div class="col-sm-3">
        <h2>Users</h2>
    </div>
    <div class="col-sm-3 d-flex align-items-center justify-content-end">
        <nb-toggle [(ngModel)]="hideGuests" (checkedChange)="onHideGuestsToggle()" style="margin-right: 10px;">
            Hide guest users
        </nb-toggle>
    </div>
    <div class="col-sm-4">
        <input style="float: right; background-color: white;" type="text" placeholder="Search Text" nbInput
            [(ngModel)]="word" (keyup)="onFilterKeySearch()" />
    </div>
    <div class="col-sm-2">
        <button style="float: right" class="btn btn-primary px-4" (click)="addUser()">
            Add User
        </button>
    </div>
</div>
<div class="col-12" style="margin-top: 20px;">
    <nb-card>
        <nb-card-body>
            <table class="table text-center">
                <thead>
                    <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone No.</th>
                        <th scope="col">Date Of Birth</th>
                        <th scope="col">Country Code</th>
                        <th *ngIf="role=='admin'" scope="col">CPR No.</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let user of source|paginate: { itemsPerPage: 10, currentPage: page, totalItems: total };let i= index ">
                        <td>{{(page - 1) * count + i + 1 + ((page - 1) * count)}}</td>
                        <td>{{user.name}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.phone}}</td>
                        <td>{{user.dateofbirth | date:'dd/MM-yyyy' }}</td>
                        <td>{{user.country}}</td>
                        <td *ngIf="role=='admin'">{{user.cprNumber}}</td>
                        <td>
                            <i style="cursor: pointer; margin-right: 5px" class="fa-regular fa-pen-to-square"
                                (click)="editUser(user._id)"></i>
                            <i style="cursor: pointer" class="fa-solid fa-trash" (click)="deleteUser(user._id)"></i>

                        </td>

                    </tr>
                </tbody>
            </table>
            <pagination-controls class="pagination" [responsive]="true" (pageChange)="pageChanged($event)"
                previousLabel="Prev" nextLabel="Next"></pagination-controls>
        </nb-card-body>
    </nb-card>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
    [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>